import { ScrollableAreaTheme } from '../types';
import { neutralColors } from '../constants/colors';

export const scrollableArea: ScrollableAreaTheme = {
  scrollBarThumb: {
    border: `2px solid ${neutralColors.black}`,
    bgColor: `${neutralColors.black}`,
    borderRadius: '0',
  },
  scrollBarTrack: {
    background: `${neutralColors.greyLighter}`,
    borderRadius: '0',
  },
};
